import { render, staticRenderFns } from "./authPay.vue?vue&type=template&id=09c44e3e&"
import script from "./authPay.vue?vue&type=script&lang=js&"
export * from "./authPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports